import { Link } from 'react-router-dom';
import { useToast } from '@/hooks/use-toast';

declare global {
  interface Window {
    fcWidget?: { open: () => void };
  }
}

export const AuthenticatedFooter = () => {
  const { toast } = useToast();

  const handleOpenChat = () => {
    const tryOpenChat = (attempts = 0) => {
      if (window.fcWidget?.open) {
        window.fcWidget.open();
        return;
      }
      
      const fw = window.FreshworksWidget as unknown as { q?: unknown } | ((action: string) => void);
      if (typeof fw === 'function' && !('q' in fw)) {
        (fw as (action: string) => void)('open');
        return;
      }
      
      if (attempts < 10) {
        setTimeout(() => tryOpenChat(attempts + 1), 300);
      } else {
        toast({
          title: "Chat Unavailable",
          description: "Please try again or email us at hello@useradius.io",
          variant: "destructive",
        });
      }
    };
    tryOpenChat();
  };

  return (
    <footer className="border-t border-border py-3 px-4 bg-background">
      <div className="flex items-center justify-center gap-2 text-xs text-muted-foreground">
        <span>© {new Date().getFullYear()} Radius</span>
        <span className="text-border">|</span>
        <Link to="/terms" className="hover:text-foreground transition-colors">
          Terms
        </Link>
        <span className="text-border">|</span>
        <Link to="/privacy" className="hover:text-foreground transition-colors">
          Privacy
        </Link>
        <span className="text-border">|</span>
        <Link to="/po-terms" className="hover:text-foreground transition-colors">
          PO Terms
        </Link>
        <span className="text-border">|</span>
        <button 
          onClick={handleOpenChat}
          className="hover:text-foreground transition-colors"
        >
          Help
        </button>
      </div>
    </footer>
  );
};
